import { PTA_BANNER_HEIGHT, TOOLBAR_HEIGHT } from 'Util/constants'
import Drawer from '@mui/material/Drawer'
import { styled } from '@mui/material/styles'

interface AppBarAwareDrawerProps {
  isPtaBannerVisible?: boolean
}

/**
 * An MUI Drawer that takes into account the height of the AppBar and PTA banner (if visible)
 * to adjust its top margin and height accordingly.
 */
const AppBarAwareDrawer = styled(Drawer, {
  shouldForwardProp: prop => prop !== 'isPtaBannerVisible'
})<AppBarAwareDrawerProps>(({ isPtaBannerVisible }) => ({
  '& .MuiDrawer-paper': {
    marginTop: `${TOOLBAR_HEIGHT + (isPtaBannerVisible ? PTA_BANNER_HEIGHT : 0)}px`,
    height: `calc(100% - ${TOOLBAR_HEIGHT + (isPtaBannerVisible ? PTA_BANNER_HEIGHT : 0)}px)`
  }
}))

export default AppBarAwareDrawer
